import { combineReducers } from 'redux';
import { reducer as reduxAsyncConnect } from 'redux-connect';

import cookies from 'common/reducers/cookies';
import jobs from 'common/reducers/jobs';
import serverResponse from 'common/reducers/serverResponse';
import viewer from 'common/reducers/viewer';

export default combineReducers({
  cookies,
  jobs,
  reduxAsyncConnect,
  serverResponse,
  viewer,
});
